<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadCompanies(1, null, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addCompany">{{ $t('add_company') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('company_name')" v-model="companySearchParams.company_name" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('dcontext')" v-model="companySearchParams.dcontext" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('webfax_content')" v-model="companySearchParams.webfaxContent" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <vs-input :placeholder="$tc('keyword')" v-model="companySearchParams.keyword" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCompanies(1, null, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="companyDataContainer" :title="$t('company')" class="mb-8 vs-con-loading__container">
      <template slot="actions">
        <shared-management-tab-nav></shared-management-tab-nav>
      </template>

      <vs-table hover-flat v-if="companies && companies.length" :data="companies">
        <template slot="thead">
          <vs-th v-text="$t('id')"></vs-th>
          <vs-th v-text="$t('company_name')"></vs-th>
          <vs-th v-text="$t('dcontext')"></vs-th>
          <vs-th v-text="$t('webfax_content')"></vs-th>
          <vs-th v-text="$tc('keyword', 2)"></vs-th>
          <vs-th class="text-center">
            {{ $t('allow_simple_crm') }}
          </vs-th>
          <vs-th class="text-center" v-text="$t('is_free')"></vs-th>
          <vs-th class="text-center" v-text="$t('use_big')"></vs-th>
          <vs-th v-text="$t('extension_number')"></vs-th>
          <vs-th class="text-center" v-text="$t('status')"></vs-th>
          <vs-th class="text-center" v-text="$t('asterisk_name')"></vs-th>
          <vs-th v-text="$t('cti_server')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>

        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.name"></vs-td>
            <vs-td v-text="tr.dcontext"></vs-td>
            <vs-td v-text="tr.webfax_content"></vs-td>
            <vs-td>
              <template v-if="tr.keywords.length > 0">
                <badge-clipboard v-for="(keyword, keywordKey) in tr.keywords" :key="keywordKey" :text="keyword.name"></badge-clipboard>
              </template>
            </vs-td>
            <vs-td class="text-center">
              <badge-enabled :enabled="tr.allow_simple_crm == 1"></badge-enabled>
            </vs-td>
            <vs-td class="text-center">
              <badge-enabled :enabled="tr.is_free == 1"></badge-enabled>
            </vs-td>
            <vs-td class="text-center">
              <badge-enabled :enabled="tr.use_big == 1"></badge-enabled>
            </vs-td>
            <vs-td>
              <template v-if="tr.extensions.length > 0">
                <badge-clipboard v-for="(extension, extensionKey) in tr.extensions" :key="extensionKey" :text="extension.number"></badge-clipboard>
              </template>
            </vs-td>
            <vs-td class="text-center">
              <badge-enabled :enabled="tr.is_active == 1"></badge-enabled>
            </vs-td>
            <vs-td v-text="tr.asterisk_name"></vs-td>
            <vs-td>
              <template v-if="tr.server != null">
                <badge-clipboard :text="`[${tr.server.name}] ${tr.server.domain}`"></badge-clipboard>
              </template>
            </vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="editCompany(tr.id)"></vs-button>&nbsp;
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="deleteCompany(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="companyPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCompanies"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="`${manageCompanyMode} company`" :active.sync="modals.manage" size="xl">
      <div id="companyEditFormDataContainer" class="vs-con-loading__container">
        <shared-manage-company
          :server-options="serverOptions"
          :mode="manageCompanyMode"
          @deleteItemsSuccess="deleteItemsSuccess"
          @submitCompanySuccess="submitCompanySuccess">
        </shared-manage-company>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="manageCompanyButton" color="primary" type="filled" @click.prevent="submitCompany">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Company from '@/models/Company'
import Paginate from '@/mixins/paginate'
import { EventBus } from '@/../eventbus'
import SharedManageCompany from '@/views/Shared/Management/Company/Manage'
import SharedManagementTabNav from '@/views/Shared/Management/TabNav'
import Modal from '@/components/Modal'

export default {
  name: 'Admin.Management.Company',
  mixins: [Paginate],
  components: {
    Modal,
    SharedManageCompany,
    SharedManagementTabNav
  },
  data () {
    return {
      companies: {},
      companyPages: 0,
      serverOptions: [],
      itemPerPage: null,
      companySearchParams: {
        company_name: '',
        dcontext: '',
        keyword: '',
        webfaxContent: ''
      },
      manageCompanyMode: 'store', // [store, edit]
      modals: {
        manage: false
      }
    }
  },
  watch: {
    'modals.manage' (val) {
      if (!val) {
        EventBus.$emit('initCompanyFormData')
      }
    }
  },
  mounted () {
    this.loadCompanies(this.initialPage, null)
  },
  methods: {
    async loadCompanies (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#companyDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await Company.findAll({...this.companySearchParams, page, itemPerPage})
      this.companies = response.data.data
      this.serverOptions = response.data.meta.options.servers
      this.companyPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#companyDataContainer > .con-vs-loading')
    },
    addCompany () {
      EventBus.$emit('initCompanyFormData')
      this.manageCompanyMode = 'store'
      this.modals.manage = true
    },
    submitCompany () {
      EventBus.$emit('initSubmitCompany')
    },
    submitCompanySuccess (response) {
      this.modals.manage = false
      this.$swalHelper.success({
        title: this.$t('action_success'),
        text: this.$t(response.data),
        confirmButton: this.$t('confirm')
      })
      this.loadCompanies(this.initialPage)
    },
    editCompany (id) {
      EventBus.$emit('initCompanyFormData')
      this.manageCompanyMode = 'edit'
      this.modals.manage = true
      EventBus.$emit('initEditCompany', id)
    },
    async deleteCompany (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await Company.destroy({ id })
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })
          this.loadCompanies()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    deleteItemsSuccess () {
      this.loadCompanies(1, null)
    },
    resetCompanyFormData () {
      EventBus.$emit('initCompanyFormData')
      // EventBus.$emit('resetTab') // TODO: Find an alternative, if there's any.
    }
  }
}
</script>

<style lang="scss">
  .v-select {
    ul {
      max-height: 100px !important;
      overflow: auto;
    }
  }

  #manageCompanyButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
